// adapt groups from new api to the same format as the one returned by old customer groups api and integrationEmployees meta data api
export const adaptGroupsToStandardFormat = (groups) =>
  groups?.map((item) => ({
    id: item.id,
    value: item.id,
    name: item.displayName,
    label: item.displayName,
    groupType: item.type,
  }))

// the new groups api doesn't return shared mailboxes, and the old api does not contain live data
// thus in many places we join the new groups (live data) with the old groups (shared mailboxes)
export const joinGroupsWithSharedMailboxes = ({ groups, sharedMailboxesGroups }) => {
  const sharedMailboxes = sharedMailboxesGroups?.filter((item) => item.groupType === 'SharedMailbox') ?? []
  const graphGroups = adaptGroupsToStandardFormat(groups) ?? []

  return [...sharedMailboxes, ...graphGroups]
}
